function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M15.7272727,14.4090909 L9.27272727,8 L15.7272727,1.59090909 C16.0909091,1.22727273 16.0909091,0.636363636 15.7272727,0.318181818 C15.3636364,1.61486985e-15 14.7727273,-0.0454545455 14.4545455,0.318181818 L8,6.72727273 L1.59090909,0.272727273 C1.22727273,-0.0909090909 0.636363636,-0.0909090909 0.318181818,0.272727273 C1.61486985e-15,0.636363636 -0.0454545455,1.22727273 0.318181818,1.54545455 L6.72727273,8 L0.272727273,14.4090909 C-0.0909090909,14.7727273 -0.0909090909,15.3636364 0.272727273,15.6818182 C0.636363636,16 1.22727273,16.0454545 1.54545455,15.6818182 L8,9.27272727 L14.4090909,15.7272727 C14.7727273,16.0909091 15.3636364,16.0909091 15.6818182,15.7272727 C16,15.3636364 16.0454545,14.7727273 15.7272727,14.4090909 Z"
});

var SvgIconX = function SvgIconX(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-X.604eb1a1.svg";
export { SvgIconX as ReactComponent };